import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import UserCardItems from './UserCardItems';

const UserCards = ({
  allowApprovedStatus,
  allowRoleLink,
  allowTools,
  allowUserLink,
  category,
  entity = 'user',
  handleScroll,
  items,
  itemsPerRow,
  onCheckBoxClick,
  readErrors,
  readStatus,
  single,
}) => (
  <InfiniteScrollCards
    className="aridhia-user-cards"
    entity={entity}
    handleScroll={handleScroll}
    icon="user"
    items={items}
    loading
    itemsPerRow={itemsPerRow}
    readErrors={readErrors}
    readStatus={[readStatus]}
  >
    <UserCardItems
      allowUserLink={allowUserLink}
      allowRoleLink={allowRoleLink}
      allowApprovedStatus={allowApprovedStatus}
      allowTools={allowTools}
      category={category}
      items={items}
      onCheckBoxClick={onCheckBoxClick}
      single={single}
    />
  </InfiniteScrollCards>
);

export default UserCards;
